const ApplicationsHistoric = () => <div>historial applications</div>

export default ApplicationsHistoric
